import {i18n} from '@yourcoach/i18n';

import InfoIcon from '../../../../assets/icons/primary/Info Circle.svg';
import {alert} from '../../../../components/alert';

export const showAlert = (message: string) => {
  alert.show({
    icon: InfoIcon,
    iconColor: 'error',
    isDismissible: true,
    message,
    title: i18n.t('shared:uh_oh'),
  });
};
